var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse, _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgUploadFileSuccess = function SvgUploadFileSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h200v200H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161.877 84.354v-6.876c0-7.685-7.369-13.886-16.501-13.886H108.69c-2.724 0-5.287-1.214-6.889-3.101L90.266 45.795c-1.602-1.887-4.165-3.1-6.889-3.1H46.691c-9.132.134-16.341 6.201-16.341 13.886v88.98c0 4.449 4.165 7.955 9.452 7.955 4.165 0 7.85-2.292 8.971-5.663l19.225-53.792c2.082-5.798 8.49-9.842 15.7-9.842h78.179v.135z",
    fill: "url(#upload-file-success_svg__paint0_linear_12884_118413)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.356 61.258v61.831H93.869h-.034c-4.67 0-8.624-2.565-9.476-6.345a7.728 7.728 0 01-.17-1.552v-12.893c0-13.4-.035-32.738-.035-39.59v-1.923-.574c0-.101 0-.203-.034-.338a10.382 10.382 0 00-6.954-8.876 9.422 9.422 0 00-2.932-.574c-.034 0-.034 0-.034-.033h56.213c6-.034 10.943 4.826 10.943 10.867z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M161.877 112.188c0 6.007-4.943 10.901-11.011 10.901h-54.61c4.602-1.113 7.976-5.197 7.976-10.091v-.81h57.645z",
    fill: "url(#upload-file-success_svg__paint1_linear_12884_118413)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.154 102.265H52.69c.681 0 1.363-.067 2.01-.202 4.841-.912 8.489-5.13 8.489-10.193V60.718c0-5.197 3.886-9.517 8.931-10.26a11.708 11.708 0 011.534-.101c.205 0 .375 0 .546.034a9.419 9.419 0 012.931.573c3.784 1.317 6.58 4.76 6.955 8.877.034.303.034.607.034.911v40.231c.034.438.034.843.034 1.282z",
    fill: "url(#upload-file-success_svg__paint2_linear_12884_118413)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.155 65.882V91.87c0 5.063-3.648 9.248-8.488 10.193a9.914 9.914 0 01-2.011.202c-5.796 0-10.466-4.657-10.466-10.361V65.882h20.965z",
    fill: "url(#upload-file-success_svg__paint3_linear_12884_118413)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M130.208 72.598H97.074a1.592 1.592 0 01-1.602-1.586v-2.126c0-.878.715-1.586 1.602-1.586h33.134c.887 0 1.603.708 1.603 1.586v2.126c0 .878-.716 1.586-1.603 1.586zM130.208 86.706H97.074a1.592 1.592 0 01-1.602-1.586v-2.126c0-.878.715-1.587 1.602-1.587h33.134c.887 0 1.603.709 1.603 1.587v2.126c0 .877-.716 1.586-1.603 1.586zM130.208 100.814H97.074a1.593 1.593 0 01-1.602-1.586V97.1c0-.877.715-1.586 1.602-1.586h33.134c.887 0 1.603.709 1.603 1.586v2.127c0 .877-.716 1.586-1.603 1.586z",
    fill: "#BFD9F1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.879 153.42L68.27 92.76l2.24 8.051-19.743 52.609h-31.89z",
    fill: "url(#upload-file-success_svg__paint4_linear_12884_118413)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.642 153.516c4.165 0 7.85-2.292 8.971-5.663L67.837 94.06c2.083-5.797 8.491-9.841 15.7-9.841H164.6c11.054 0 18.904 8.898 15.861 17.796l-14.419 41.524c-2.082 5.932-8.491 9.977-15.86 9.977H39.642z",
    fill: "url(#upload-file-success_svg__paint5_linear_12884_118413)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 180.322,
    rx: 52.275,
    ry: 2.273,
    fill: "#E1E3F9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 127.205,
    cy: 39.61,
    r: 22.205,
    fill: "#64CC82"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#upload-file-success_svg__clip0_12884_118413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.012 26.071c-6.044.102-11.525 2.897-15.671 7.048-2.472 2.476-4.682 5.168-6.883 7.863-1.373-2.058-2.861-4.044-4.529-5.89-1.333-1.48-3.917-1.235-5.28-.09-1.43 1.186-1.983 3.524-.781 5.134 2.429 3.256 4.71 6.573 6.607 10.156 1.252 2.36 4.976 2.452 6.589.588 3.345-3.872 6.43-7.968 10.038-11.623 3.437-3.493 6.801-7.278 11.031-9.844 1.59-.966.688-3.362-1.107-3.329l-.014-.013z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "upload-file-success_svg__paint0_linear_12884_118413",
    x1: 96.114,
    y1: 42.695,
    x2: 96.114,
    y2: 163.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D07328"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "upload-file-success_svg__paint1_linear_12884_118413",
    x1: 191.331,
    y1: 117.624,
    x2: -60.623,
    y2: 117.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFD9F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "upload-file-success_svg__paint2_linear_12884_118413",
    x1: 68.414,
    y1: 93.405,
    x2: 68.414,
    y2: 23.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BADEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "upload-file-success_svg__paint3_linear_12884_118413",
    x1: 52.673,
    y1: 84.046,
    x2: 52.673,
    y2: 150.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E2EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "upload-file-success_svg__paint4_linear_12884_118413",
    x1: 121.929,
    y1: 96.762,
    x2: 95.497,
    y2: 166.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#684232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6753D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "upload-file-success_svg__paint5_linear_12884_118413",
    x1: 110.381,
    y1: 84.219,
    x2: 110.381,
    y2: 160.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEDAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29857"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "upload-file-success_svg__clip0_12884_118413"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(17.269 2.417 402.018)",
    d: "M0 0h31.372v32.085H0z"
  })))));
};
export default SvgUploadFileSuccess;